import { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem("cookieConsent");
    if (!cookieConsent) {
      // Small delay for better UX
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setIsVisible(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem("cookieConsent", "necessary");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-fade-in-up"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-[0_-8px_30px_rgb(0,0,0,0.1)] border border-gray-100 p-6">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-[#F6E05E]/30 rounded-xl flex items-center justify-center flex-shrink-0">
            <Cookie className="w-6 h-6 text-[#744210]" />
          </div>
          
          <div className="flex-1">
            <h3 
              className="text-lg font-bold text-[#2D3748] mb-2"
              style={{ fontFamily: 'Nunito' }}
            >
              🍪 Diese Website verwendet Cookies
            </h3>
            <p className="text-[#718096] text-sm mb-4">
              Wir nutzen nur technisch notwendige Cookies, um diese Website sicher und funktionsfähig zu halten. 
              Diese Cookies speichern keine persönlichen Daten und werden nicht für Werbung verwendet. 
              Mehr Informationen findest du in unserer{" "}
              <Link to="/datenschutz" className="text-[#A0E8AF] hover:underline font-medium">
                Datenschutzerklärung
              </Link>.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                onClick={acceptCookies}
                className="bg-[#A0E8AF] text-[#1A4731] hover:bg-[#86D696] rounded-full px-6 py-2 font-bold transition-all"
                data-testid="accept-all-cookies"
              >
                Alle akzeptieren
              </Button>
              <Button
                onClick={acceptNecessary}
                variant="outline"
                className="border-2 border-gray-200 text-[#718096] hover:bg-gray-50 rounded-full px-6 py-2 font-medium transition-all"
                data-testid="accept-necessary-cookies"
              >
                Nur notwendige
              </Button>
            </div>
          </div>

          <button
            onClick={acceptNecessary}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Schließen"
          >
            <X className="w-5 h-5 text-[#A0AEC0]" />
          </button>
        </div>
      </div>
    </div>
  );
}
